import { render } from "./Index.vue?vue&type=template&id=67c07e5e"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import "./Index.vue?vue&type=style&index=0&id=67c07e5e&lang=css"

import exportComponent from "C:\\AgentPools\\FAOAgentPool\\_work\\32\\s\\WEPTW_Web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__